import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getTagsListStatus, getTagsList } from '@store/reducers/blog/selectors';
import { getTags, clearStatus, deleteTag } from '@store/actions/blog';
import { getPermittedPermissions } from '@store/reducers/check-permission/selectors';
import { setIsPermissionCheckedAction, checkPermissionAction } from '@store/actions/check-permission';
import Main from './Main';

const mapStateToProps = state => ({
  tags: getTagsList(state),
  status: getTagsListStatus(state),
  permittedPermissions: getPermittedPermissions(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getTags,
      clearStatus,
      deleteTag,
      setIsPermissionCheckedAction,
      checkPermissionAction,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
